import getEquipmentFiltersExercisesSelect from '../../../../exercises-ui/selectors/get-equipment-filters'
import getMusclesFiltersExercisesSelect from '../../../../exercises-ui/selectors/get-muscles-filters'
import getQueryExercisesSelect from '../../../../exercises-ui/selectors/get-query'
import getTypesFiltersExercisesSelector from '../../../../exercises-ui/selectors/get-types-filters'
import { EXERCISES_ACTION, EXERCISES_DOMAIN, EXERCISES_ENDPOINT } from '../../constants'
import getFoundExercisesSelect from '../../selectors/get-found'
import { PAGINATION_LIMIT_DEFAULT } from '../../../../redux/constants/query-params'
import { logUtil } from 'packages/src'
import loadDomainReduxAction from '../../../../redux/actions/load'
import REDUX_OPTION from '../../../../redux/constants/option'
import getByQueryPathReduxUtil from '../../../../redux/utils/get-by-query-path'

function loadExercisesAction (params = {}) {
  return async (dispatch, getState) => {
    try {
      const query = params.query || {
        limit: PAGINATION_LIMIT_DEFAULT
      }

      const q = getQueryExercisesSelect(getState())
      if (q) {
        query.q = q.toLowerCase()
      }

      if (params.shouldUseFilters) {
        const types = getTypesFiltersExercisesSelector(getState())
        const muscles = getMusclesFiltersExercisesSelect(getState())
        const equipment = getEquipmentFiltersExercisesSelect(getState())
        if (types.length) {
          query.type = types[0]
        }
        if (muscles.length) {
          query.muscles = muscles.join(',')
        }
        if (equipment.length) {
          query.equipment = equipment.join(',')
        }
      }

      let excludedIds
      if (params.shouldExcludeIds) {
        excludedIds = getFoundExercisesSelect()(getState())
      }
      if (excludedIds && excludedIds.length) {
        query.excludedIds = excludedIds.join(',')
      }

      const options = params.options || {}
      options[REDUX_OPTION.NO_AUTH_NEEDED] = true
      await dispatch(loadDomainReduxAction({
        type: EXERCISES_ACTION.LOAD,
        payload: {
          endpoint: EXERCISES_ENDPOINT.EXERCISES,
          domainListPath: getByQueryPathReduxUtil(EXERCISES_DOMAIN, query.q),
          ...params,
          options,
          query
        }
      }))
    } catch (error) {
      logUtil('').warn('loading exercises failed: ', error)
    }
  }
}

export { loadExercisesAction }
